import React, {
  useMemo,
  memo
} from "react";
import {
  StyleSheet
} from "react-native";
import {
  Card
} from "@constants/Themed";
import MonthlyBarChart from "@components/Charts/MonthlyBarChart";
import {
  getBarChartConfig,
  MODERN_CHART_COLORS
} from "@utils/chartTheme";
import {
  themeSelector
} from "@reduxLocal/selectors/themeSelector";

interface MonthlyBarChartWidgetProps {
  data: number;
  isLoading: boolean;
  width: number;
  height: number;
}

const MonthlyBarChartWidget: React.FC<MonthlyBarChartWidgetProps> = ({
  data,
  isLoading,
  width,
  height,
}) => {
  const theme = themeSelector();
  const barChartConfig = useMemo(() => getBarChartConfig("modern", theme), [
    theme,
  ]);

  const monthlyData = useMemo(
    () => ({
      labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun"],
      datasets: [{
        data: [
          data,
          data * 1.2,
          data * 0.8,
          data * 1.5,
          data * 1.1,
          data * 1.3,
        ],
        color: (opacity = 1) =>
          `${MODERN_CHART_COLORS.bar.primary}${Math.round(opacity * 255)
            .toString(16)
            .padStart(2, "0")}`,
        strokeWidth: 2,
      },],
    }), [data]
  );

  return (
    <Card style={styles.card}>
      <MonthlyBarChart
        data={monthlyData}
        isLoading={isLoading}
        chartConfig={barChartConfig}
        width={width}
        height={height}
      />
    </Card>
  );
};

const styles = StyleSheet.create({
  card: {
    width: "100%",
    height: "100%",
    borderRadius: 15,
    overflow: "hidden",
    padding: 16,
    justifyContent: "center",
    alignItems: "center",
    flex: 1,
  },
});

export default memo(MonthlyBarChartWidget);
